<template>
  <div class="api-doc-page-container">
    <a-page-header :title="apiConfig?.name + ' - 接口文档'" @back="handleBack">
      <template #extra>
        <a-button @click="handleBack">返回列表</a-button>
      </template>
    </a-page-header>

    <a-card style="margin-top: 16px">
      <a-tabs v-model:activeKey="activeTab">
        <a-tab-pane key="post" tab="POST 接口" v-if="apiConfig?.methods?.post">
          <ApiDoc :config="apiConfig.methods.post" />
        </a-tab-pane>
        <a-tab-pane key="get" tab="GET 接口" v-if="apiConfig?.methods?.get">
          <ApiDoc :config="apiConfig.methods.get" />
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { getApiConfig } from '../utils/apiConfigs';
import ApiDoc from '../components/ApiDoc.vue';

export default {
  name: 'ApiDocPage',
  components: {
    ApiDoc
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const apiConfig = ref(null);
    const activeTab = ref('post');

    const handleBack = () => {
      router.push('/api-management');
    };

    onMounted(() => {
      const apiId = route.params.apiId || route.query.apiId;
      if (apiId) {
        apiConfig.value = getApiConfig(apiId);
        if (apiConfig.value) {
          activeTab.value = apiConfig.value.methods.post ? 'post' : 'get';
        }
      }
    });

    return {
      apiConfig,
      activeTab,
      handleBack
    };
  }
};
</script>

<style scoped>
.api-doc-page-container {
  padding: 24px;
}
</style>

